import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { Link } from '@material-ui/core';
import { Close } from '@material-ui/icons';

import { palette, Typography as T } from '@dev/ee-components';
import { MarketingOptions } from '@dev/ee-api/ee-api-models';

import { links } from '@/services/dictionaries/links';
import { isReseller } from '@/services/Secuirty';
import { AccountEditMarketingOptionsStart, getAccountStore } from '@/store/account/actions';
import SegmentsImage from '@/services/Layout/icons/segments.svg';

const ImageWrapper = styled.div`
    margin: 24px 48px;
    background: ${palette.indigo[1]};
    border: 1px solid ${palette.gray[3]};
    border-radius: 4px;
    display: flex;
    justify-content: space-between;
    position: relative;
    .textWrapper {
        max-width: 60%;
        padding: 24px 0px 24px 40px;
    }
    .imageWrapper {
        max-width: 40%;
    }
    .closeIcon {
        position: absolute;
        top: 10px;
        right: 10px;
        cursor: pointer;
        fill: ${palette.gray[7]};
    }
`;

export const WelcomeImageComponent: FC = (): JSX.Element => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const account = useSelector(getAccountStore);
    const showMarketingOption = !account?.GeneralInfo?.MarketingOptions.includes(
        MarketingOptions.SegmentsInfoDisplayed
    );

    const handleCloseImage = (): void => {
        const newMarketingOptions = [...account.GeneralInfo.MarketingOptions];
        newMarketingOptions.push(MarketingOptions.SegmentsInfoDisplayed);
        dispatch(AccountEditMarketingOptionsStart(newMarketingOptions));
    };

    if (!showMarketingOption) {
        return null;
    }

    return (
        <ImageWrapper>
            <div className="textWrapper">
                <T variant="h2">{t('segments')}</T>
                <T variant="body1">
                    {t('createsegmentdesc')}{' '}
                    {!isReseller(account) && (
                        <Link href={links.contactListsAndSegments} rel="noreferrer" target="_blank">
                            {t('learnmore')}
                        </Link>
                    )}
                </T>
            </div>
            <div className="imageWrapper">
                <SegmentsImage />
            </div>
            <Close className="closeIcon" fontSize="large" onClick={handleCloseImage} />
        </ImageWrapper>
    );
};
